export default __webpack_public_path__ + "static/media/Italy.e1d5e2a5.svg";